export const CATS = ["smt", "mi", "fatp"];

export const sectionCat = (masters, sectionId) => {
  const code = masters.sections.find((s) => s.id === sectionId)?.code?.toLowerCase();
  return CATS.includes(code) ? code : null;
};

// Options for the "Project / Model" selector: projects with UPH for the line's section category + line-specific models
export function runOptions(masters, line) {
  if (!line) return [];
  const cat = sectionCat(masters, line.section_id);
  const projects = cat
    ? (masters.projects || []).filter((p) => p.active && p[`${cat}_uph`] > 0).map((p) => {
        const mp = cat === "smt" ? (p.smt_mp || p.total_mp) : p.total_mp;
        return {
          value: `p:${p.id}`, id: p.id, kind: "project", name: p.name, uph: p[`${cat}_uph`], manpower: mp,
          uph_per_head: mp ? Math.round((p[`${cat}_uph`] / mp) * 100) / 100 : null,
          mva: p[`${cat}_mva`] || 0, label: `${p.name} · ${p[`${cat}_uph`]} UPH · MP ${mp}`,
        };
      })
    : [];
  const models = (masters.models || []).filter((m) => m.line_id === line.id && m.active).map((m) => ({
    value: `m:${m.id}`, id: m.id, kind: "model", name: m.name, uph: m.uph, manpower: m.manpower, mva: 0,
    uph_per_head: m.uph_per_head, cycle_time_sec: m.cycle_time_sec, label: `${m.name} · ${m.uph} UPH · MP ${m.manpower} (line model)`,
  }));
  const lineModels = (line.models && line.models.length ? line.models : (line.uph > 0 ? [{ name: line.model_name || line.name, uph: line.uph }] : [])).map((m, i) => ({
    value: `l:${line.id}:${i}`, id: line.id, kind: "line", name: m.name, line_model: m.name, uph: m.uph, manpower: 0, mva: 0,
    uph_per_head: null, label: `${m.name} · ${m.uph} UPH (line master)`,
  }));
  return [...lineModels, ...projects, ...models];
}

export const runPayload = (opt) => (opt ? (opt.kind === "project" ? { project_id: opt.id, model_id: null, line_model: null } : opt.kind === "model" ? { model_id: opt.id, project_id: null, line_model: null } : { project_id: null, model_id: null, line_model: opt.line_model }) : {});

// True when a Daily Plan model name resolves to a production run option (project / model / line model) on this line
export function modelSetUpForLine(masters, lineId, modelName) {
  const line = (masters.lines || []).find((l) => l.id === lineId);
  if (!line) return true;
  const key = (modelName || "").trim().toLowerCase();
  if (!key) return true;
  return runOptions(masters, line).some((o) => (o.name || "").trim().toLowerCase() === key || (o.label || "").toLowerCase().startsWith(key));
}
